exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkTerms a[data-v-8d487c54]{text-decoration:underline}.linkTerms a[data-v-8d487c54]:hover{text-decoration:none}", ""]);

// exports
